import React, { Component } from 'react'
import { Player } from 'video-react'
import {
  SecondaryP,
  PrimaryDiv,
  DivHeroMask,
  StyledTagSection,
  DivWithBackgroundColor,
} from '../shared-page-components/styled-components.js'

export default class CaseStudyHeader extends Component {
  render() {
    const {
      caseStudyBackgroundColor,
      caseStudyPrimaryColor,
      caseStudySecondaryColor,
      displayTitle,
      headerDisplayTitleFont,
      headerLayout,
      heroImageObject,
      heroVideoObject,
      heroImageCrop,
      introductionText,
      industry,
      services,
      title,
    } = this.props

    return (
      <PrimaryDiv
        primaryTextColor={caseStudyPrimaryColor}
        id="case-study-header"
      >
        <header className="grid-row full-page">
          <div className="grid-row hero-mask">
            {heroImageCrop !== 'span-0-12' && (
              <DivHeroMask
                backgroundColor={caseStudyBackgroundColor}
                className={`mask ${heroImageCrop} gutter`}
              />
            )}
          </div>

          <div className="grid-row hero-mask hero">
            {heroVideoObject && (
              <div className="hero-video-content">
                <div className="video-cover" />
                <Player
                  ref="player"
                  muted
                  loop
                  fluid
                  autoPlay
                  playsInline
                  poster={heroVideoObject.videoPosterImage.file.url}
                  className="hero-video"
                >
                  <source src={heroVideoObject.videoUrl} />
                </Player>
              </div>
            )}

            {heroImageObject && (
              <div
                className="hero-image"
                style={{
                  backgroundImage: `url(${
                    heroImageObject.heroImage.file.url
                  }?w=3000&h=1247&fit=fill&q=90)`,
                }}
              />
            )}
          </div>
        </header>

        {headerLayout === 'overlapped' && (
          <section className="case-study-title grid-row">
            <div className="section-column">
              <h1
                className={headerDisplayTitleFont}
                dangerouslySetInnerHTML={{ __html: displayTitle }}
              />
            </div>
          </section>
        )}

        {headerLayout === 'stacked' && (
          <section className="case-study-title grid-row">
            <div className="section-column">
              <h1
                className={headerDisplayTitleFont}
                dangerouslySetInnerHTML={{ __html: displayTitle }}
              />
            </div>
          </section>
        )}

        <DivWithBackgroundColor
          className="case-study-introduction grid-row"
          backgroundColor={caseStudyBackgroundColor}
        >
          <div className="section-column">
            <div className="grid-row no-gutter">
              <StyledTagSection
                primaryTextColor={caseStudyPrimaryColor}
                secondaryTextColor={caseStudySecondaryColor}
                className="tag-lists"
              >
                {industry &&
                  !services && (
                    <div>
                      <TagList title="Industry" items={industry} />
                      <TagList title=" " items={''} />
                    </div>
                  )}

                {services &&
                  !industry && (
                    <div>
                      <TagList title="Services" items={services} />
                      <TagList title=" " items={''} />
                    </div>
                  )}

                {services &&
                  industry && (
                    <div>
                      <TagList title="Industry" items={industry} />
                      <TagList title="Services" items={services} />
                    </div>
                  )}
              </StyledTagSection>

              <section className="introduction">
                <SecondaryP
                  secondaryTextColor={caseStudySecondaryColor}
                  dangerouslySetInnerHTML={{
                    __html: introductionText.introductionText,
                  }}
                />
              </section>
            </div>
          </div>
        </DivWithBackgroundColor>
      </PrimaryDiv>
    )
  }
}

class TagList extends Component {
  render() {
    const { title, items } = this.props
    const itemsToArray = items.toString().split(',')

    return (
      <div className="tag-list">
        <h3>{title}</h3>
        <ol>
          {itemsToArray.map((item, i) => {
            return <li key={`${title}_${i}`}>{item}</li>
          })}
        </ol>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/case-studies/case-study-header.js